import TableComponent from "../../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Column } from "react-table";
import { formatDate, formatTime } from "../../../helpers/dateUtils";

interface TableTerrainProps {
  dataTable: any[];
  isLoaded: boolean;
}

const TableTerrain: FC<TableTerrainProps> = ({ dataTable, isLoaded }) => {
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      {
        Header: "Ordem",
        Cell: ({ row }: any) => row.index + 1,
        disableSortBy: true,
      },
      {
        Header: "Data/Hora",
        accessor: "createdAt",
        Cell: ({ value }: any) => (
          <>
            {value
              ? `${formatDate(new Date(value))}, ${formatTime(new Date(value))}`
              : "-"}
          </>
        ),
      },
      { Header: "Detalhes", accessor: "description", disableSortBy: true },
    ];

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTable]);

  return (
    <TableComponent isLoaded={isLoaded} columns={columns} data={dataTable} />
  );
};

export default TableTerrain;
